export default class AssessmentsEditPillars {

  constructor() {}

  render() {

    // Listen for submit form
    const checkEnabledStatusOfSubmit = function() {

      // Get selected category IDs
      if ($('input:checkbox:checked').length > 0) {
        $('.disabled-button').addClass('d-none');
        $('.enabled-button').removeClass('d-none');
      } else {
        $('.disabled-button').removeClass('d-none');
        $('.enabled-button').addClass('d-none');
      }
    }

    // Action when clicking on a card
    // Check the box when click a row or a checkbox in a row
    $('.PillarContainer').on('click', function() {
      let hiddenCheckbox = $(this).find('input.hidden-ccid');
      let hiddenDestroy = $(this).find('input.hidden-destroy');

      // Check/uncheck the box and update val, depending on current state
      // Also update active class of card
      // Also update hidden id field of assessment category
      if (hiddenCheckbox[0].checked === false) {
        hiddenCheckbox.prop('checked', true);
        hiddenCheckbox.val(hiddenCheckbox.attr("data-pillar-id"));
        hiddenDestroy.val('false');
        $(this).addClass('active');        

      } else if (hiddenCheckbox[0].checked === true) {
        hiddenCheckbox.prop('checked', false);
        hiddenCheckbox.val("");
        hiddenDestroy.val('true');
        $(this).removeClass('active');
      }

      // Blur focus; required in touch to update active class
      $(this).blur();

      // Enable/disable submit buton
      checkEnabledStatusOfSubmit();

    });

    // Prevent submitting form on disabled button click
    $('.disabled-button').click(function(e) {
      e.preventDefault();
    });
    // Submit form (custom button text doesn't work with default Rails f.submit)
    $('.submit-pillars').click(function() {
      $('#pillars_form').submit();
    })

  }

}